<template>
  <v-container>
    <nav class="navbar navbar-inverse navbar-fixed-top style">
      <div class="container-fluid col-sm-12 col-md-12 col-xs-12">
        <ul class="nav navbar-nav navbar-right hidden-sm-and-down">
          <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
            <template v-slot:activator="{ on }">
              <v-btn color="#4376a2" dark v-on="on">Contacto</v-btn>
            </template>

            <v-card>
              <v-list>
                <v-list-tile avatar>
                  <v-list-tile>
                    <img height="60" :src="img2" />
                  </v-list-tile>

                  <v-list-tile-content>
                    <v-list-tile-title class="color-contacto">Departamento de Calidad y Acreditación</v-list-tile-title>
                    <v-list-tile-sub-title>Contacto</v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action></v-list-tile-action>
                </v-list-tile>
              </v-list>

              <v-divider></v-divider>

              <v-list>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon right>email</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title class="color-contacto">omar.soto@usach.cl</v-list-tile-title>
                </v-list-tile>
              </v-list>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="primary" flat @click="menu = false">cerrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </ul>
        <div class="navbar-header">
          <v-btn class="hidden-md-and-up button-personal" icon @click="changeButton()">
            <v-icon>list</v-icon>
          </v-btn>
          <img :src="img1" height="55" width="auto" />
        </div>
        <ul class="nav navbar-nav navbar-right hidden-sm-and-down toppadding">
          <v-chip color="#4376a2" text-color="white">
            {{this.$session.getAll().ccData.nombre}}
            <v-icon color="white" right>account_balance</v-icon>
          </v-chip>
        </ul>
      </div>
    </nav>
    <v-layout row>
      <v-flex md2 lg2 sm0 xs0>
        <v-navigation-drawer v-if="mini" stateless touchless value="true" fixed>
          <v-list>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>home</v-icon>
              </v-list-tile-action>

              <v-list-tile-title>Autoevaluación</v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{name:'archivosDca'}" v-if="type=='dca'" active-class="fix-position">
              <v-list-tile-title v-text="'Subir archivos'"></v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-if="this.$session.getAll().userType == 'postgradodca' || this.$session.getAll().userType == 'prorrector' || this.$session.getAll().userType == 'vipo'"
              :to="{name:'ccm'}"
            >
              <v-list-tile-title>Cambiar carrera</v-list-tile-title>
            </v-list-tile>

            <v-list-group>
              <template v-slot:activator>
                <v-list-tile @click="redirect('intro1')">
                  <v-list-tile-title>Autoevaluación</v-list-tile-title>
                </v-list-tile>
              </template>

              <v-list-group no-action sub-group v-if="this.$session.getAll().userType != 'vipo'">
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Información Básica</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-tile :to="{name:'documentos'}" active-class="fix-position">
                  <v-list-tile-title v-text="'Información Básica'"></v-list-tile-title>
                </v-list-tile>
              </v-list-group>

              <v-list-group
                no-action
                sub-group
                v-if="(etapa.etapa1Dca || this.$session.getAll().userType == 'postgradodca') && this.$session.getAll().userType != 'vipo'"
              >
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Evaluación de Indicadores</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-tile
                  v-for="(criterio, i) in criterios"
                  :key="i"
                  :to="{name:'indicadoresEvidencia', params: { id: i }}"
                >
                  <v-list-tile-title v-text="criterio"></v-list-tile-title>
                </v-list-tile>
              </v-list-group>

              <v-list-group
                no-action
                sub-group
                v-if="(etapa.etapa2Dca || this.$session.getAll().userType == 'postgradodca') && this.$session.getAll().userType != 'vipo'"
              >
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Evaluación de dimensiones</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-group no-action sub-group class="pading-group">
                  <template v-slot:activator>
                    <v-list-tile :to="{name:'dimension', params: { id: 1 }}">
                      <v-list-tile-title>Propósitos</v-list-tile-title>
                    </v-list-tile>
                  </template>
                  <v-list-tile
                    :to="{name:'criterio', params: { id: 1 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Criterio 1'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="{name:'criterio', params: { id: 2 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Criterio 2'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="{name:'criterio', params: { id: 3 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Criterio 3'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="{name:'criterio', params: { id: 4 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Criterio 4'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="{name:'criterio', params: { id: 5 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Criterio 5'"></v-list-tile-title>
                  </v-list-tile>
                </v-list-group>

                <v-list-group no-action sub-group class="pading-group">
                  <template v-slot:activator>
                    <v-list-tile :to="{name:'dimension', params: { id: 2 }}">
                      <v-list-tile-title>Organización</v-list-tile-title>
                    </v-list-tile>
                  </template>
                  <v-list-tile
                    :to="{name:'criterio', params: { id: 6 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Criterio 6'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="{name:'criterio', params: { id: 7 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Criterio 7'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="{name:'criterio', params: { id: 8 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Criterio 8'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="{name:'criterio', params: { id: 9 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Criterio 9'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="{name:'criterio', params: { id: 10 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Criterio 10'"></v-list-tile-title>
                  </v-list-tile>
                </v-list-group>

                <v-list-group no-action sub-group class="pading-group">
                  <template v-slot:activator>
                    <v-list-tile :to="{name:'dimension', params: { id: 3 }}">
                      <v-list-tile-title>Resultados</v-list-tile-title>
                    </v-list-tile>
                  </template>
                  <v-list-tile
                    :to="{name:'criterio', params: { id: 11 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Criterio 11'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="{name:'criterio', params: { id: 12 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Criterio 12'"></v-list-tile-title>
                  </v-list-tile>
                </v-list-group>
                <v-list-tile :to="{name:'d1post'}" active-class="fix-position">
                  <v-list-tile-title v-text="'Debilidades y Fortalezas'"></v-list-tile-title>
                </v-list-tile>
              </v-list-group>

              <v-list-group
                no-action
                sub-group
                v-if="(etapa.etapa3Dca || this.$session.getAll().userType == 'postgradodca') && this.$session.getAll().userType != 'vipo'"
              >
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Plan de mejoramiento</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-tile :to="{name:'d1P'}" active-class="fix-position">
                  <v-list-tile-title v-text="'Definición de Acciones'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile :to="{name:'indicadores'}" active-class="fix-position">
                  <v-list-tile-title v-text="'Definición de indicadores'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile :to="{name:'hitos'}" active-class="fix-position">
                  <v-list-tile-title v-text="'Etapa de Seguimiento y Gestión'"></v-list-tile-title>
                </v-list-tile>
              </v-list-group>

              <v-list-group
                no-action
                sub-group
                v-if="etapa.etapa4Dca || this.$session.getAll().userType == 'postgradodca' || this.$session.getAll().userType == 'vipo'"
              >
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Revisión DCA</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-tile :to="{name:'documentos45'}" active-class="fix-position">
                  <v-list-tile-title v-text="'Documentación'"></v-list-tile-title>
                </v-list-tile>
              </v-list-group>

              <v-list-group
                no-action
                sub-group
                v-if="etapa.etapa5Dca || this.$session.getAll().userType == 'postgradodca' || this.$session.getAll().userType == 'vipo'"
              >
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Acta y aprobación</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-tile :to="{name:'documentosActa'}" active-class="fix-position">
                  <v-list-tile-title v-text="'Acta y aprobación'"></v-list-tile-title>
                </v-list-tile>
              </v-list-group>
            </v-list-group>

            <v-list-tile @click="logout()">
              <v-list-tile-action>
                <v-icon>arrow_back</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Cerrar Sesión</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-navigation-drawer>
      </v-flex>
      <!-- lado derecho del contenido -->
      <v-flex md10 sm12 xs12>
        <div class="container">
          <router-view></router-view>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
//import Test from './Test'
//import Form from './Form'
//import Criterio from './Criterio'
import img1 from "../../assets/LOGO USACH.png";
import img2 from "../../assets/logo.jpeg";

export default {
  name: "Sidebar",
  props: ["data"],
  components: {
    //Test,
    //Form,
    //Criterio,
  },

  data() {
    return {
      type: "",
      img2: img2,
      menu: false,
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      etapa: "",
      criterios: [
        "Matrícula nueva",
        "Vacantes ofrecidas",
        "Caracterización estudiantes",
        "Retención primer año",
        "Retención total",
        "Tasa de egreso",
        "Tasa de titulación",
        "Titulación oportuna",
        "Tiempo real de titulación",
        "Empleabilidad",
        "Inserción ocupacional"
      ],
      on: false,
      esMayor: "",
      drawer: true,
      drawerRight: true,
      right: true,
      left: null,
      test: "hidden-sm-and-down",
      img1: img1,
      admins: [
        ["Management", "people_outline"],
        ["Settings", "settings"]
      ],
      cruds: [
        ["Create", "add"],
        ["Read", "insert_drive_file"],
        ["Update", "update"],
        ["Delete", "delete"]
      ],
      mini: true,
      drawer: true
    };
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      if (this.$route.fullPath == "/introDca") this.initObservacionGral();
    }
  },

  created() {
    //console.log(this.$session.getAll().userType);
    this.type = this.$session.getAll().userType;
    this.esMayor = this.$session.getAll().ccData.esMayor;
    this.initObservacionGral();
  },
  methods: {
    initObservacionGral() {
      axios
        .get(
          process.env.ROOT_API +
            "/etapa/etapaUsuario?idPostgrado=" +
            this.$session.getAll().ccData.id,
          this.auth
        )
        .then(response => {
          //console.log("ANEXOS");
          //console.log(response.data);
          this.etapa = response.data;
        })
        .catch(error => {
          //console.log("ERROR ANEXOS");
          console.error(error);
          this.showAlert("error", error.response.data);
        });
    },
    closeBar() {
      this.mini = false;
    },
    openBar() {
      this.mini = true;
    },
    changeButton() {
      //console.log("kjashdkjaHSDK");
      if (this.mini == false) {
        this.openBar();
      } else {
        this.closeBar();
      }
    },
    redirect(index) {
      this.$router.push({ name: index });
    },

    logout() {
      this.$session.destroy();
      this.$router.push("/");
    }
  }
};
</script>

<style >
.pull-subgrupo {
  padding-left: 5%;
}
.v-navigation-drawer--fixed {
  padding-top: 70px;
  padding-bottom: 50px;
  display: block;
  left: 0;
  max-width: 250px !important;
  overflow-y: auto;
  overflow-x: hidden;
  pointer-events: auto;
  top: 0;
  will-change: transform;
  z-index: 3;
  transition-delay: 2s;
}

.container-pro {
  align-items: left;
  margin-top: 70px;
  padding-bottom: 50px;
  left: 0;
  z-index: 6;
  position: fixed;
}

.button-personal {
  align-self: left;
}

.theme--light.v-navigation-drawer {
  background-color: #4376a2 !important;
}

.v-list__group__header--active .v-list__group__header__prepend-icon .v-icon {
  color: #90d2f8 !important;
}

.theme--light.v-icon {
  color: #90d2f8 !important;
}

.primary {
  background-color: #273039 !important;
}

.style {
  background: white !important;
  border-top: 3px solid #5dabd8 !important;
  border-bottom: 7px solid #b1b1b1 !important;
  background-color: #1c345d !important;
  height: 70px;
}

.img-style {
  text-align: right;
}

.fix-position {
  background: #80b8d8;
  text-decoration-line: none !important;
  text-decoration: none !important;
}

.pading-group {
  padding-left: 25px !important;
}
.toppadding {
  padding-top: 5px !important;
}
</style>



<style scoped>
.v-list__tile__title {
  color: white !important;
}

.color-contacto {
  color: black !important;
}
</style>




// WEBPACK FOOTER //
// src/components/template/SideBar.vue